import { computed, ref } from "vue";

import type { UseTrackedState } from "@/App/components/patient/types/UseTrackedState";
import { InitialState, Loading, LoadingFailed, LoadingSucceeded } from "@/Pages/utils/DataState";

export const useTrackedState: UseTrackedState = ({ fn, onFulfilled, onRejected, onSettled, state }) => {
  const dataState = ref(new InitialState());

  const isInitial = computed(() => state.dataState instanceof InitialState);

  const isLoading = computed(() => state.dataState instanceof Loading);

  const isSuccessful = computed(() => state.dataState instanceof LoadingSucceeded);

  const isFailed = computed(() => state.dataState instanceof LoadingFailed);

  const promise = (...input: unknown[]): Promise<void> => {
    state.dataState = new Loading();

    const actualInput = input ?? [];

    let resolve: (argument: undefined) => void;

    const p = new Promise<void>((_resolve) => {
      resolve = _resolve;
    });

    fn?.(...actualInput)
      .then(async (value) => {
        state.dataState = new LoadingSucceeded({ data: await onFulfilled(value) });
      })

      .catch((reason: unknown) => {
        const [message, source] = onRejected(reason);

        state.dataState = new LoadingFailed(message, source);
      })

      .finally(() => {
        onSettled?.();

        resolve(undefined);
      });

    return p;
  };

  Object.assign(state, { dataState, isInitial, isLoading, isSuccessful, isFailed });

  return promise;
};
